module.exports = __webpack_public_path__ + "static/media/brake-repair-red.04e231c5.svg";